import script from "./singlecell_info.vue?vue&type=script&setup=true&lang=js"
export * from "./singlecell_info.vue?vue&type=script&setup=true&lang=js"

import "./singlecell_info.vue?vue&type=style&index=0&id=54a0e692&scoped=true&lang=css"

import exportComponent from "D:\\Desktop\\项目\\xiongxi\\vue-notus-main\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54a0e692"]])

export default __exports__